import { TError } from '../errors';
import { MuiToastTypes } from './utils';
import { reportActionCreators } from '../report/state';

export const showPermissionErrorToast = (err: TError) => {
  if (err.status === 403) {
    reportActionCreators.toggleMuiToast({
      type: MuiToastTypes.FAILURE,
      headerText: 'Permission Error',
      bodyText:
        "It seems you don't have permission to perform this action. Please contact your administrator if you need access."
    });
  }
};
